import { JsonObject, JsonProperty } from 'json2typescript';

/**
 * å¸çº§è¡æ¿åº
 */
@JsonObject
export class City {
  /**
   * å¸çº§è¡æ¿åºId
   */
  @JsonProperty('id', Number)
  id: number = undefined;

  /**
   * å¸çº§è¡æ¿åºåç§°
   */
  @JsonProperty('name', String)
  name: string = undefined;

  /**
   * æå±ççº§è¡æ¿åºId
   */
  @JsonProperty('provinceId', Number)
  provinceId: number = undefined;
}
